import { render, staticRenderFns } from "./ai_catalog_item_consumer_disclaimer.vue.js?vue&type=template&id=2e579943&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_item_consumer_disclaimer.vue?vue&type=template&id=2e579943&vue3"
import script from "./ai_catalog_item_consumer_disclaimer.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_item_consumer_disclaimer.vue?vue&type=script&lang=js&vue3"
export * from "./ai_catalog_item_consumer_disclaimer.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_item_consumer_disclaimer.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports